module.exports = __webpack_public_path__ + "static/media/faqImg1000.fd51d723.jpeg";